import { QueryClient } from "@tanstack/react-query";
import { GC_TIME } from "./cachePolicy";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Padrão curto de propósito: vale para o que não declarou política
      // própria — inclusive os dados de acesso do aluno. Quem pode esperar
      // mais declara o seu `staleTime` (ver cachePolicy.js).
      staleTime: 1000 * 60 * 5, // 5 minutes
      // Mantém o dado em memória depois que a tela sai do ar, senão o
      // `staleTime` longo das consultas de marca/conteúdo seria descartado
      // junto e a leitura aconteceria de novo na volta.
      gcTime: GC_TIME,
    },
  },
});
